import { create } from 'zustand';

type ProposalActionsRequestState = {
  /** Bumped on every request, so the same proposal can ask twice. */
  count: number;
  request: () => void;
};

/**
 * A click on the proposal that is already selected changes no selection, so the
 * build panel cannot see it. The proposal bar bumps this to open Actions.
 */
const useProposalActionsRequestStore = create<ProposalActionsRequestState>()(
  (set) => ({
    count: 0,
    request: () => set(({ count }) => ({ count: count + 1 })),
  }),
);

export const useProposalActionsRequestCount = (): number =>
  useProposalActionsRequestStore(({ count }) => count);

export const useRequestProposalActions = (): (() => void) =>
  useProposalActionsRequestStore(({ request }) => request);
